module.exports = __webpack_public_path__ + "img/Hawaiian Meal-Gardein Soy-Chicken.ef90de94.jpg";